import { useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { type ReceiverProfile, getGetProfileQueryKey } from '@dhl/receiver-profile-api'
import {
  useDeleteUser as useApiDeleteUser,
  useGetUserLogout,
  usePostUserUpdateName,
} from '@dhl/receiver-user-service-api'

import { links } from '~/links.js'

export const useDeleteUser = (): ReturnType<typeof useApiDeleteUser> => {
  const { refetch: logoutUser } = useGetUserLogout({
    query: {
      enabled: false,
    },
  })
  const { i18n } = useTranslation()

  return useApiDeleteUser({
    language: i18n.language,
    mutation: {
      onSuccess: async () => {
        await logoutUser()

        window.location.href = links.accountLink()
      },
    },
  })
}

export const useUpdateUserName = (): ReturnType<typeof usePostUserUpdateName> => {
  const queryClient = useQueryClient()

  return usePostUserUpdateName({
    mutation: {
      onSuccess: async (_, { data: { firstName, lastName } }) => {
        await queryClient.setQueryData(getGetProfileQueryKey(), (profile: ReceiverProfile) => ({
          ...profile,
          firstName,
          lastName,
        }))
      },
    },
  })
}
